type BuildPathParams = Record<string, string | number | boolean | null | undefined>;

const buildPath = (base: string, params?: BuildPathParams) => {
  const search = new URLSearchParams();

  Object.entries(params ?? {}).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    search.set(key, String(value));
  });

  const query = search.toString();
  return query ? `${base}?${query}` : base;
};

export { buildPath };
